import clsx from 'clsx';

/**
 * Badge — semantic status pill.
 *
 * Props:
 *   tone - "neutral" | "success" | "warning" | "danger" | "info" | "brand"
 *   size - "sm" (default) | "md"
 *   icon - optional lucide icon
 */
const TONES = {
  neutral: 'bg-inset text-body',
  success: 'bg-success-bg text-success-dark',
  warning: 'bg-warning-bg text-warning-dark',
  danger:  'bg-danger-bg  text-danger-dark',
  info:    'bg-info-bg    text-info-dark',
  brand:   'bg-brand-subtle text-brand',
};

const SIZES = {
  sm: 'px-1.5 py-px text-[9.5px]',
  md: 'px-2.5 py-1 text-xs',
};

export function Badge({ children, tone = 'neutral', size = 'sm', icon, className = '' }) {
  return (
    <span className={clsx(
      'inline-flex items-center gap-1 rounded-pill font-semibold whitespace-nowrap leading-tight font-sans',
      TONES[tone], SIZES[size], className,
    )}>
      {icon}
      {children}
    </span>
  );
}
